import './_components.js';
import './components/accordion.js';
import { burger } from './functions/burger.js';
AOS.init();


